function formatCPF(cpf) {
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

function formatCNPJ(cnpj) {
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1 $2 $3/$4-$5");
}

function document(customer) {
  if (customer.type === "physicals") {
    return `CPF ${formatCPF(customer.cpf)}`;
  }

  return `CNPJ ${formatCNPJ(customer.cnpj)}`;
}

export default {
  formatCPF,
  formatCNPJ,
  document
};



// WEBPACK FOOTER //
// ./src/utils/formatters/documentId.js